@for (funding of fundings(); track funding.Id) {
  <div class="employee-basket-fundings-list__row">
    <span class="employee-basket-fundings-list__title">
      {{ funding.TenantGroupFundingType | flexyooLocalizedName: currLang() }}
    </span>
    <span class="employee-basket-fundings-list__amount">
      {{ funding.BudgetAmount | flexyooNumber }}
    </span>
  </div>
}
